import React, { useState } from 'react'
import moreStyle from './moreInfo.module.css'
require('typeface-poppins')


export default function MoreInfo({ region, category, willing, genre, authorIllu }) {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${moreStyle.contactAccordion} accordion mb-3`} id="ContactInfo">
                <div className={`${moreStyle.contactMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${moreStyle.contactbuttonItem} ${moreStyle.moreBeforebg} accordion-button ${openIndex === 0 ? '' : `${moreStyle.morebgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            More Info
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ContactInfo">
                        <div className={`${moreStyle.moreBody} accordion-body`}>
                            <div className={moreStyle.contactinfoWrapper}>
                                <div className={moreStyle.contactInner}>
                                    <div className={`${moreStyle.contactTitle} w-50`}>
                                        <h6> Willing to Travel? </h6>
                                    </div>
                                    <div className={`${moreStyle.contactDetails} w-50`}>
                                        <p> {willing} </p>
                                    </div>
                                </div>
                                <div className={moreStyle.contactInner}>
                                    <div className={`${moreStyle.contactTitle} w-50`}>
                                        <h6> Region </h6>
                                    </div>
                                    <div className={`${moreStyle.contactDetails} w-50`}>
                                        <p> {region} </p>
                                    </div>
                                </div>
                                <div className={moreStyle.contactInner}>
                                    <div className={`${moreStyle.contactTitle} w-50`}>
                                        <h6> Category </h6>
                                    </div>
                                    <div className={`${moreStyle.contactDetails} w-50`}>
                                        <p> {category} </p>
                                    </div>
                                </div>
                                <div className={moreStyle.contactInner}>
                                    <div className={`${moreStyle.contactTitle} w-50`}>
                                        <h6> Genre </h6>
                                    </div>
                                    <div className={`${moreStyle.contactDetails} w-50`}>
                                        <p> {genre} </p>
                                    </div>
                                </div>
                                <div className={moreStyle.contactInner}>
                                    <div className={`${moreStyle.contactTitle} w-50`}>
                                        <h6> Author or Illustrator </h6>
                                    </div>
                                    <div className={`${moreStyle.contactDetails} w-50`}>
                                        <p> {authorIllu} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


